import { PriceOverrideStatus } from "@classes-service-types/index";

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 100, 5000];
export const ROWS_PER_PAGE_DROPDOWN_OPTIONS = ROWS_PER_PAGE_OPTIONS.map((val) => ({ key: `${val}`, value: val }));

export const STATUS_TO_LABEL_MAP = {
  [PriceOverrideStatus.Rejected]: "Decline",
};

export const REJECTED_HIDDEN_COLUMNS = ["approved_date", "requested_date"];
export const APPROVED_HIDDEN_COLUMNS = ["rejected_date", "requested_date"];
export const NEEDS_REVIEW_HIDDEN_COLUMNS = ["approved_date", "rejected_date", "view_details"];
export const REVERTED_HIDDEN_COLUMNS = ["approved_date", "rejected_date", "requested_date", "view_details"];
export const DEFAULT_HIDDEN_COLUMNS = ["approved_date", "rejected_date", "requested_date"];

export const COLUMN_OPTIONS = [
  { key: "id", name: "Id" },
  { key: "order_id", name: "Order Id" },
  { key: "program_session_id", name: "Program Session Id" },
  { key: "name", name: "Experience" },
  { key: "product_type", name: "Product Type" },
  { key: "override_amount_in_cents", name: "Request Amount" },
  { key: "original_amount_in_cents", name: "Original Amount" },
  { key: "difference_amount_in_cents", name: "Difference Amount" },
  { key: "override_reason", name: "Reason" },
  { key: "decision_date", name: "Decision Date" },
  { key: "requested_by", name: "Requested By" },
  { key: "request_notes", name: "Requested Notes" },
  { key: "decided_by", name: "Decided By" },
  { key: "decision_notes", name: "Decision Notes" },
  { key: "city_ascii", name: "City Name" },
  { key: "view_details", name: "View Details" },
  { key: "approved_date", name: "Approved Date" },
  { key: "requested_date", name: "Requested Date" },
  { key: "rejected_date", name: "Declined Date" },
];
export const COLUMNS_NOT_TO_ENABLE_AT_LOAD = [
  "id",
  "difference_amount_in_cents",
  "city_ascii",
  "order_id",
  "decision_notes",
  "decision_date",
  "decided_by",
  "program_session_id",
  "requested_by",
  "request_notes",
];
